// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  font-family: "GothamBold", "Helvetica Neue", Helvetica,Arial, sans-serif;
}
.containerImageTitle {
    position: relative;
    display: inline-block;
  }   
  .imageTitle {
    width: 100%; 
    height: auto;
  }   
  .imageTitleText {
    position: absolute;
    bottom: 7px; 
    left: 40px; 
    color: white;
    font-size: 20px; 
    font-weight: bold;
    padding: 5px;
    border-radius: 5px;
  }
  .loading-spinner {
    display: block;
    margin: 0 auto;
  }
  .header-container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    pointer-events: none;
  }
  
  .header-container input {
    margin-top: 5px;
    width: 100%; 
    pointer-events: auto; 
  }
.heading-box {
  text-align: left;
  background-color: #F1F1F1;
  border: solid 1px #d4d4d4;
  margin-bottom: 50px;
  background-color: #187a9b;
  color: white;
  padding: 10px;
  border-radius: 5px 5px 0 0;
  display: block;
  width: 100%;
  box-sizing: border-box;
}
.doa-select-text {
  color: white;
  padding: 10px;
  background-color: #0b2d71;
  text-align: left;
  border-radius: 5px 5px 5px 5px;
  max-width:100%;
}
.my-holidaylist-select-text {
  color: white;
  padding: 10px;
  background-color: #286090;
  text-align: left;
  border-radius: 5px 5px 0 0;
  font-family: "GothamBold",Arial,sans-serif;
}
.addbtn{
  float:left;
  padding-left:670px;
}`, "",{"version":3,"sources":["webpack://./src/app/admin/holiday_list/holiday_list.component.css"],"names":[],"mappings":"AAAA;EACE,wEAAwE;AAC1E;AACA;IACI,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;EACpB;EACA;IACE,cAAc;IACd,cAAc;EAChB;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,WAAW;IACX,oBAAoB;EACtB;AACF;EACE,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,0BAA0B;EAC1B,cAAc;EACd,WAAW;EACX,sBAAsB;AACxB;AACA;EACE,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,gBAAgB;EAChB,8BAA8B;EAC9B,cAAc;AAChB;AACA;EACE,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,gBAAgB;EAChB,0BAA0B;EAC1B,0CAA0C;AAC5C;AACA;EACE,UAAU;EACV,kBAAkB;AACpB","sourcesContent":[":host {\n  font-family: \"GothamBold\", \"Helvetica Neue\", Helvetica,Arial, sans-serif;\n}\n.containerImageTitle {\n    position: relative;\n    display: inline-block;\n  }   \n  .imageTitle {\n    width: 100%; \n    height: auto;\n  }   \n  .imageTitleText {\n    position: absolute;\n    bottom: 7px; \n    left: 40px; \n    color: white;\n    font-size: 20px; \n    font-weight: bold;\n    padding: 5px;\n    border-radius: 5px;\n  }\n  .loading-spinner {\n    display: block;\n    margin: 0 auto;\n  }\n  .header-container {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    pointer-events: none;\n  }\n  \n  .header-container input {\n    margin-top: 5px;\n    width: 100%; \n    pointer-events: auto; \n  }\n.heading-box {\n  text-align: left;\n  background-color: #F1F1F1;\n  border: solid 1px #d4d4d4;\n  margin-bottom: 50px;\n  background-color: #187a9b;\n  color: white;\n  padding: 10px;\n  border-radius: 5px 5px 0 0;\n  display: block;\n  width: 100%;\n  box-sizing: border-box;\n}\n.doa-select-text {\n  color: white;\n  padding: 10px;\n  background-color: #0b2d71;\n  text-align: left;\n  border-radius: 5px 5px 5px 5px;\n  max-width:100%;\n}\n.my-holidaylist-select-text {\n  color: white;\n  padding: 10px;\n  background-color: #286090;\n  text-align: left;\n  border-radius: 5px 5px 0 0;\n  font-family: \"GothamBold\",Arial,sans-serif;\n}\n.addbtn{\n  float:left;\n  padding-left:670px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
